import {
  USERS_CLOSE_ADD_MODAL,
  USERS_CLOSE_EDIT_MODAL,
  USERS_CLOSE_VIEW_MODAL,
  USERS_EDIT_MODAL_OPEN_AND_FETCH,
  USERS_MODAL_SET_USER,
  USERS_OPEN_ADD_MODAL,
  USERS_VIEW_MODAL_OPEN_AND_FETCH,
  GET_USER_PENDING,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  LOAD_USERS,
  USER_SAVE_PENDING,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAILURE,
  USER_SAVE,
  DELETE_USER_PENDING,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER,
  USER_EDIT_PENDING,
  USER_EDIT_SUCCESS,
  USER_EDIT_FAILURE,
  USER_EDIT,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_PENDING,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAILURE,
  //CHANGE_PASSWORD
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
} from "./constants";
const actions = {
  openUsersAddModal: (payload) => {
    return {
      type: USERS_OPEN_ADD_MODAL,
      payload,
    };
  },
  closeUsersAddModal: (payload) => {
    return {
      type: USERS_CLOSE_ADD_MODAL,
      payload,
    };
  },
  usersViewModalStartFetching: (payload) => {
    return {
      type: USERS_VIEW_MODAL_OPEN_AND_FETCH,
      payload,
    };
  },
  usersModalSetUser: (payload) => {
    return {
      type: USERS_MODAL_SET_USER,
      payload,
    };
  },
  closeUsersViewModal: (payload) => {
    return {
      type: USERS_CLOSE_VIEW_MODAL,
      payload,
    };
  },
  closeUsersEditModal: (payload) => {
    return {
      type: USERS_CLOSE_EDIT_MODAL,
      payload,
    };
  },
  usersEditModalStartFetching: (payload) => {
    return {
      type: USERS_EDIT_MODAL_OPEN_AND_FETCH,
      payload,
    };
  },
  loadUsersPending: (payload) => {
    return {
      type: GET_USER_PENDING,
      payload,
    };
  },
  loadUsersSuceess: (payload) => {
    return {
      type: GET_USER_SUCCESS,
      payload,
    };
  },
  loadUsersFailure: (payload) => {
    return {
      type: GET_USER_FAILURE,
      payload,
    };
  },
  loadUsers: (payload) => {
    return {
      type: LOAD_USERS,
      payload,
    };
  },
  // Save Users

  saveUser: (payload) => {
    return {
      type: USER_SAVE,
      payload,
    };
  },
  saveUserPending: (payload) => {
    return {
      type: USER_SAVE_PENDING,
      payload,
    };
  },
  saveUserSuccess: (payload) => {
    return {
      type: USER_SAVE_SUCCESS,
      payload,
    };
  },
  saveUserFailure: (payload) => {
    return {
      type: USER_SAVE_FAILURE,
      payload,
    };
  },

  // Edit Users

  editUser: (payload) => {
    return {
      type: USER_EDIT,
      payload,
    };
  },
  editUserPending: (payload) => {
    return {
      type: USER_EDIT_PENDING,
      payload,
    };
  },
  editUserSuccess: (payload) => {
    return {
      type: USER_EDIT_SUCCESS,
      payload,
    };
  },
  editUserFailure: (payload) => {
    return {
      type: USER_EDIT_FAILURE,
      payload,
    };
  },

  // For delete users
  deleteUser: (payload) => {
    return {
      type: DELETE_USER,
      payload,
    };
  },
  deleteUserPending: (payload) => {
    return {
      type: DELETE_USER_PENDING,
      payload,
    };
  },
  deleteUserSuccess: (payload) => {
    return {
      type: DELETE_USER_SUCCESS,
      payload,
    };
  },
  deleteUserFailure: (payload) => {
    return {
      type: DELETE_USER_FAILURE,
      payload,
    };
  },
  // update profile
  updateUserProfile: (payload) => {
    return {
      type: UPDATE_USER_PROFILE,
      payload,
    };
  },
  updateUserProfilePending: (payload) => {
    return {
      type: UPDATE_USER_PROFILE_PENDING,
      payload,
    };
  },
  updateUserProfileSuccess: (payload) => {
    return {
      type: UPDATE_USER_PROFILE_SUCCESS,
      payload,
    };
  },
  updateUserProfileFailure: (payload) => {
    return {
      type: UPDATE_USER_PROFILE_FAILURE,
      payload,
    };
  },

  chagePassword: (payload) => {
    return {
      type: CHANGE_PASSWORD,
      payload,
    };
  },
  chagePasswordSuccess: (payload) => {
    return {
      type: CHANGE_PASSWORD_SUCCESS,
    };
  },
  chagePasswordFailure: (payload) => {
    return {
      type: CHANGE_PASSWORD_FAILURE,
      payload,
    };
  },
};
export default actions;
